<template>
  <b-table striped :items="filteredItems" :fields="hideResolvedColumn === true ? ['raised_at_utc', 'message'] : ['raised_at_utc', 'message', 'is_resolved']">
    <template slot="raised_at_utc" slot-scope="data">
      {{ data.value.value | moment('D/MM/YY HH:mm') }}
    </template>
    <template slot="message" slot-scope="data">
      <div v-if="data.item.topic" style="font-weight:bold">{{ data.item.topic }}</div>
      {{ data.value || 'Health-check report received' }}
    </template>
    <template slot="is_resolved" slot-scope="data">
      <traffic-light-icon :pass="data.value"/>
    </template>
  </b-table>
</template>

<script>
import TrafficLightIcon from './TrafficLightIcon.vue';

export default {
  props: ['items', 'hideResolvedColumn', 'hideResolved'],
  components: { TrafficLightIcon },
  computed: {
    filteredItems() {
      if (!this.hideResolved) {
        return this.items;
      }
      return this.items.filter(i => !i.is_resolved);
    }
  }
}
</script>
